export default "__VITE_ASSET__b6e199c7__"